import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Switch, Typography } from 'shared/ui'
import { useChatbotContext } from 'pages/chatbot/context'
import styles from './styles.module.scss'

export const PointAIQualify = observer(() => {
  const {
    model: { settings },
  } = useChatbotContext()
  const handleQualifyEnabledChange = (status: boolean) => {
    settings.setQualifyEnabled(status)
  }

  return (
    <div className={styles.container}>
      <div className={classNames(styles.section, styles.quality)}>
        <div className={styles.qualityLabelContainer}>
          <Typography
            variant='text-input-field-r'
            color={'var(--content-primary-primary)'}
            ariaLabel={'AIQualifyLabel'}
          >
            AI Qualify
          </Typography>
          <Typography
            variant='body-xs-medium'
            ariaLabel='AIQualifyBetaLabel'
            className={styles.qualityBadge}
          >
            Beta
          </Typography>
        </div>
        <Switch value={settings.qualifyEnabled} onChange={handleQualifyEnabledChange} />
      </div>
    </div>
  )
})
